//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { getContentLibraryAggregateV2 } from '@apis/content-library/contentLibraryApi';
import {
  ContentLibraryFilter,
  ContentLibrarySortType,
} from '@apis/content-library/contentLibraryApiModel';
import {
  MediaLibrarySearchTagHeaders,
  MediaLibrarySearchTagPrefixes,
} from '@components/media-filters/mediaFilterConstants';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

const VISUAL_TAGS_LIMIT = 12;

export interface VisualTagsSuggestionsV2Params {
  query: ContentLibraryFilter;
  sortByDistanceTo: string;
}

export const getVisualTagsSuggestionsV2QueryOptions = ({
  query,
  sortByDistanceTo,
}: VisualTagsSuggestionsV2Params) =>
  queryOptions({
    queryKey: [
      QueryKeyConstants.MediaFilters,
      QueryKeyConstants.MediaFiltersVisualTagsSuggestions,
      { query, sortByDistanceTo },
    ],
    queryFn: ({ signal }) =>
      getContentLibraryAggregateV2(
        {
          limit: VISUAL_TAGS_LIMIT,
          offset: 0,
          orderBy: ContentLibrarySortType.TIME,
          query,
          sortByDistanceTo,
          type: 'VisualTags',
        },
        { signal },
      ),
    select: ({ terms }) =>
      terms.map(({ count, termName }) => ({
        count,
        header: MediaLibrarySearchTagHeaders.semanticTags,
        label: termName,
        prefix: MediaLibrarySearchTagPrefixes.semanticTags,
      })),
    staleTime: FIVE_MINUTES_STALE_TIME,
    placeholderData: keepPreviousData,
  });
